import { ref } from "vue";
import http from "axios";

export function useWork(filter) {
    const works = ref([]);
    const getWorks = async (f) => {
        let r = await http.get('/api/works/');
        works.value = r.data.works;
        if (f) {
            works.value = f(works.value);
            works.value.forEach(w => {
                if (w.children) w.children = f(w.children);
            });
        }
    }
    getWorks(filter).then();

    return { works, getWorks };
}

export function useGenre(filter) {
    const genres = ref([]);
    const getGenres = async (f) => {
        let r = await http.get('/api/genres/');
        genres.value = r.data.genres;
        if (f) {
            genres.value = f(genres.value);
            genres.value.forEach(g => {
                if (g.children) g.children = f(g.children);
            });
        }
    }
    getGenres(filter).then();

    return { genres, getGenres };
}

export function useSkill(filter) {
    const skills = ref([]);
    const getSkills = async (f) => {
        let r = await http.get('/api/skills/');
        skills.value = r.data.skills;
        if (f) {
            skills.value = f(skills.value);
            skills.value.forEach(s => {
                if (s.children) s.children = f(s.children);
            });
        }
    }
    getSkills(filter).then();

    return { skills, getSkills };
}

export function hasAbility(val, items) {
    return items.some(item => item.id == val.id) || val.children?.some(c => items.some(item => item.id == c.id));
}

export function useBmodel(filter) {
    const bmodels = ref([]);
    const getBmodels = async (f) => {
        let r = await http.get('/api/bmodels/');
        bmodels.value = r.data.bmodels;
        if (f) bmodels.value = f(bmodels.value);
    }
    getBmodels(filter).then();

    return { bmodels, getBmodels };
}

export function useEposition(filter) {
    const epositions = ref([]);
    const getEpositions = async (f) => {
        let r = await http.get('/api/epositions/');
        epositions.value = r.data.epositions;
        if (f) epositions.value = f(epositions.value);
    }
    getEpositions(filter).then();

    return { epositions, getEpositions };
}

export function usePrefecture(filter) {
    const prefectures = ref([]);
    const getPrefectures = async (f) => {
      let r = await http.get('/api/prefectures/');
      prefectures.value = r.data.prefectures;
      if (f) prefectures.value = f(prefectures.value);
    }
    getPrefectures(filter).then();

    return { prefectures, getPrefectures };
}

export function useRegion() {
    const regions = ref([
        { id: 1, name: "東北" },
        { id: 2, name: "関東" },
        { id: 3, name: "中部" },
        { id: 4, name: "近畿" },
        { id: 5, name: "中国" },
        { id: 6, name: "四国" },
        { id: 7, name: "九州" },
        { id: 8, name: "海外" },
    ]);

    return { regions };
}
